
import { defineComponent, onMounted } from "vue";
import { useScript } from "@/helper";
import Layout from "@/templates/layout/Layout.vue";
import { dictionary } from "@/compositions/pageComposition";

export default defineComponent({
  name: "Privacy",
  components: { Layout },
  setup() {
    onMounted(() => useScript("privacy"));
    return {
      lang: dictionary,
    };
  },
});
